// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2cWxpW-IO3QEx- {\n  display: flex;\n  padding: 8px 16px 8px 8px;\n}\n._287Ef2GtAxrzx9 {\n  display: flex;\n}\n._287Ef2GtAxrzx9._3y5bd1YJVTLArf {\n  justify-content: flex-start;\n  flex-grow: 2;\n}\n._287Ef2GtAxrzx9._2FkLDwzm4oLwEU {\n  justify-content: flex-end;\n  flex-grow: 1;\n}\n._1cW74ZsGFU4vUH {\n  padding-left: 8px;\n  font-size: 16px;\n  line-height: 32px;\n  font-weight: 500;\n  min-width: 76px;\n  text-align: center;\n}\n._1PZw9nWyur5Dxb {\n  margin: 0 20px;\n}\n._1PZw9nWyur5Dxb .ZEcZmeVqy4d5eb {\n  margin: 0 2px;\n  height: 32px;\n  padding: 0 8px;\n  vertical-align: bottom;\n}\n._12T5CWu4Gac5eM {\n  line-height: 32px;\n}\n._10gViqQFwuEzhW {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n._35UTwa8k0cL52z {\n  border-left: 1px solid #DFE1E6;\n  height: 16px;\n  margin: 8px 4px 8px 6px;\n  border-radius: 10px 10px 0 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": "_2cWxpW-IO3QEx-",
	"headerSection": "_287Ef2GtAxrzx9",
	"leftSection": "_3y5bd1YJVTLArf",
	"rightSection": "_2FkLDwzm4oLwEU",
	"dateText": "_1cW74ZsGFU4vUH",
	"navigationButtons": "_1PZw9nWyur5Dxb",
	"navigationButton": "ZEcZmeVqy4d5eb",
	"loading": "_12T5CWu4Gac5eM",
	"closeButton": "_10gViqQFwuEzhW",
	"divider": "_35UTwa8k0cL52z"
};
export default ___CSS_LOADER_EXPORT___;
